export function getWidgetProps (type, props) {
  const properties = {}
  switch (type) {
    case 'LmListBuilder':
      properties.name = props?.name || ''
      properties.title = props?.title || ''
      properties.dataOrigin = props?.dataOrigin || null
      properties.dataQuery = props?.dataQuery || {}
      properties.sizes = props?.sizes || [12]
      properties.aggToRender = props?.aggToRender || null
      properties.availableIn = props?.availableIn || ['inbox', 'dashboard']
      break
    case 'LmDataTableBuilder':
      properties.name = props?.name || ''
      properties.title = props?.title || ''
      properties.dataOrigin = props?.dataOrigin || null
      properties.dataQuery = props?.dataQuery || {}
      properties.sizes = props?.sizes || [12]
      properties.availableIn = props?.availableIn || ['inbox', 'dashboard', 'report']
      break
    case 'LmCounterBuilder':
      properties.name = props?.name || ''
      properties.title = props?.title || ''
      properties.dataOrigin = props?.dataOrigin || null
      properties.calculate = props?.calculate || null
      properties.dataQuery = props?.dataQuery || {}
      properties.sizes = props?.sizes || [3]
      properties.availableIn = props?.availableIn || ['inbox', 'dashboard', 'report']
      break
    case 'LmTitleBuilder':
      properties.name = props?.name || ''
      properties.title = props?.title || ''
      properties.dataOrigin = props?.dataOrigin || null
      properties.dataQuery = props?.dataQuery || {}
      properties.sizes = props?.sizes || [12]
      properties.availableIn = props?.availableIn || ['inbox', 'dashboard', 'report']
      break
    case 'LmEChartPieBuilder':
      properties.name = props?.name || ''
      properties.title = props?.title || ''
      properties.dataOrigin = props?.dataOrigin || null
      properties.aggTerm = props?.aggTerm || null
      properties.sizes = props?.sizes || [12]
      properties.size = props?.size || 10
      properties.availableIn = props?.availableIn || ['inbox', 'dashboard', 'report']
      properties.orient = props?.orient || 'horizontal'
      properties.gridOrient = props?.gridOrient || 'vertical'
      properties.overflow = props?.overflow || 'break'
      properties.scroll = props?.scroll || 'plain'
      properties.width = props?.width || null
      properties.gridWidth = props?.gridWidth || 60
      properties.gridTop = props?.gridTop || 85
      properties.top = props?.top || 40
      properties.gridRight = props?.gridRight || 20
      properties.itemGap = props?.itemGap || 12
      properties.icon = props?.icon || 'roundRect'
      properties.height = props?.height || 400
      break
    case 'LmEChartBarsBuilder':
      properties.name = props?.name || ''
      properties.title = props?.title || ''
      properties.dataOrigin = props?.dataOrigin || null
      properties.aggTerm = props?.aggTerm || null
      properties.sizes = props?.sizes || [12]
      properties.size = props?.size || 10
      properties.availableIn = props?.availableIn || ['inbox', 'dashboard', 'report']
      properties.orient = props?.orient || 'horizontal'
      properties.gridOrient = props?.gridOrient || 'vertical'
      properties.overflow = props?.overflow || 'break'
      properties.scroll = props?.scroll || 'plain'
      properties.width = props?.width || null
      properties.gridWidth = props?.gridWidth || 60
      properties.gridTop = props?.gridTop || 85
      properties.top = props?.top || 40
      properties.gridRight = props?.gridRight || 20
      properties.itemGap = props?.itemGap || 12
      properties.icon = props?.icon || 'roundRect'
      properties.height = props?.height || 400
      break
    default:
      break
  }
  return properties
}

export function getWidgetCustomizationProps (widget) {
  const customization = {}
  switch (widget) {
    case 'LmList':
      customization.color = ''
      customization.size = ''
      customization.title = ''
      break
    case 'LmDataTable':
      customization.color = ''
      customization.size = ''
      customization.title = ''
      break
    case 'LmTitle':
      customization.title = 'Un gran título separador'
      customization.size = ''
      break
    case 'LmCounter':
      customization.title = ''
      customization.icon = ''
      customization.size = ''
      break
    case 'LmEChartPie':
      customization.theme = 'light'
      customization.size = ''
      customization.title = ''
      break
    case 'LmEChartBars':
      customization.theme = 'light'
      customization.size = ''
      customization.title = ''
      break
    default:
      break
  }
  return customization
}
